import React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import GA4React from 'ga-4-react';

const container = document.getElementById('root') as HTMLElement

let root;

if (container) {
  root = createRoot(container);
} else {
  console.error('Could not find root element');
}

if (!root) throw new Error('Could not find root element');

const ga4react = new GA4React('G-47XS6XQLBV' , {
  debug_mode: true
});

(async () => {
  try {
    await ga4react.initialize();
  } catch (error) {
    console.error(error);
  }

  root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
